import { UserIcon, FacilityIcon, SearchIcon } from './icons'
import { AvatarContainer, SelectedSearchOption, SearchOption } from './style'

export const formatZipCode = (zip: string) => {
  if (zip.length <= 5) return zip
  return `${zip.slice(0, 5)}-${zip.slice(5)}`
}

export const formatOptionLabel = (
  { value, label, type }: { value: string; label: string; type: string },
  { context }: { context: string }
) => {
  const avatar = (
    <AvatarContainer className="avatar">
      {type === 'provider' && <UserIcon color="#237D83" />}
      {type === 'facility' && <FacilityIcon color="#237D83" />}
      {(type === 'specialty' || type === 'service') && (
        <SearchIcon color="#237D83" />
      )}
    </AvatarContainer>
  )

  // This won't show beacuse we will not use selected option logic
  if (context === 'value') {
    return (
      <SelectedSearchOption>
        {avatar}
        <div>
          <p className="text-muted">{label}</p>
        </div>
      </SelectedSearchOption>
    )
  }

  return (
    <SearchOption>
      {avatar}
      <div>
        <h6>{label}</h6>
        {value && <p className="text-muted">{value}</p>}
      </div>
    </SearchOption>
  )
}

export const mapSearchList = (providersData: any[]) => {
  return providersData?.length
    ? providersData.map((x: any) => {
        switch (x.type) {
          case 'facility': {
            const { facility_physician_group_name, location, id } = x.value
            const { address_line_1, address_line_2, city, state, zip_code } =
              location
            return {
              type: x.type,
              label: facility_physician_group_name,
              value: `${address_line_1}${
                address_line_2 ? ` ${address_line_2}` : ''
              }, ${city}, ${state} ${formatZipCode(zip_code)}`,
              id: id
            }
          }

          case 'provider': {
            const { first_name, last_name, specialties, location, id } = x.value
            const { city, state } = location
            return {
              type: x.type,
              label: `${first_name} ${last_name}`,
              value: `${specialties?.join(', ')} - ${city}, ${state}`,
              id: id
            }
          }

          // specialty and service
          default:
            return {
              type: x.type,
              label: x.value,
              value: x.value
            }
        }
      })
    : []
}
